
<template>
  <page-list
    :list="list"
    :columns="columns"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import * as R from 'ramda'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import { getStatusFilter } from '@/utils/common/tableFilter'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import consts from '@scope/constants/consts'

export default {
  name: 'TenantList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    getParams: {
      type: [Function, Object],
    },
    cloudEnv: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'customers',
        getParams: this.getParam,
        filterOptions: {
          enterprise_name: {
            label: '企业名称',
          },
          status: getStatusFilter({ title: this.$t('scope.text_426'), field: 'certified_status', statusModule: 'tenant' }),
          providers: {
            label: this.$t('scope.text_504'),
            dropdown: true,
            items: [
              { label: 'Google', key: 'Google' },
              { label: 'Aliyun', key: 'Aliyun' },
              { label: 'Huawei', key: 'Huawei' },
            ],
          },
          name: {
            label: this.$t('scope.text_903'),
            filter: true,
            formatter: val => {
              return `name.contains(${val})`
            },
          },
          mobile: {
            label: this.$t('scope.text_494'),
            filter: true,
            formatter: val => {
              return `mobile.contains(${val})`
            },
          },
          customer_level: {
            label: this.$t('scope.text_904'),
            dropdown: true,
            items: [
              { label: consts.customerLevelMap[0], key: '0' },
              { label: consts.customerLevelMap[1], key: '1' },
              { label: consts.customerLevelMap[2], key: '2' },
              { label: consts.customerLevelMap[3], key: '3' },
            ],
            filter: true,
            formatter: val => {
              return `customer_level.in(${val})`
            },
          },
        },
        responseData: this.responseData,
      }),
      exportDataOptions: {
        items: [
          { label: this.$t('scope.text_318'), key: 'enterprise_name' },
          { label: this.$t('scope.text_426'), key: 'certified_status' },
          { label: this.$t('scope.text_498'), key: 'created_at' },
          { label: this.$t('scope.text_504'), key: 'providers' },
          { label: this.$t('scope.text_907'), key: 'project_domain' },
          { label: this.$t('scope.text_322'), key: 'name' },
          { label: this.$t('scope.text_494'), key: 'mobile' },
          { label: this.$t('scope.text_904'), key: 'customer_level' },
        ],
      },
    }
  },
  watch: {
    cloudEnv (val) {
      this.$nextTick(() => {
        this.list.fetchData(0)
      })
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = { ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams), is_agent: false }
      if (this.cloudEnv) ret['@certified_status'] = this.cloudEnv
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'TenantManagerSidePage', {
        id: row.id,
        resource: 'customers',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
